import { useQuery } from "@tanstack/react-query";
import { useOrg360Api } from "./useOrg360Api";
import type { Org360NodeDetail } from "@/components/organisms/org360/org360Types";

export function useOrg360NodeDetail(nodeKey: string | null) {
  const { getJson, orgId } = useOrg360Api();

  return useQuery({
    queryKey: ["org360-node", orgId, nodeKey],
    queryFn: async () => {
      if (!nodeKey) return null;
      const res = await getJson<{ ok: boolean; data: Org360NodeDetail }>("/api/node", {
        org_id: orgId,
        key: nodeKey,
      });
      return res?.data ?? null;
    },
    enabled: !!orgId && !!nodeKey,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
